module.exports = __webpack_public_path__ + "img/1920_nav_img3.31839821.png";